import VideoScoringSection from './VideoScoringSection';

export default VideoScoringSection;
